import React from 'react'
import sendSvg from '../../img/icons/send.svg';
import styled from 'styled-components';

const Icon = styled.img`
    width: 35px;
    background-color: #1dd760;
    border-radius: 50%;
    padding: 5px;
`;

export const SendIcon = ({...props}) => <Icon src={sendSvg} {...props}/>


// WEBPACK FOOTER //
// ./src/components/Icons/SendIcon.js